import { render, staticRenderFns } from "./EventEmptyHomeLayout.vue?vue&type=template&id=ea6367e2"
import script from "./EventEmptyHomeLayout.vue?vue&type=script&lang=js"
export * from "./EventEmptyHomeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports